import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { HierarchiesField } from '@/utils/enum';
import { useGetCellules } from '@/hooks/useGetCellules';
import { SelectWithCreation } from '@/components/ui/Inputs';
import { hierarchyHandler } from '@/utils/hierarchy-handler';

const { useFormInstance, useWatch } = Form;

export function Cellules(): JSX.Element {
	const form = useFormInstance();
	const field_name = HierarchiesField.CELLULE;
	const sector_id = useWatch(HierarchiesField.SECTOR, form);
	const company_id = useWatch(HierarchiesField.COMPANY, form);
	const organization_id = useWatch(HierarchiesField.ORGANIZATION, form);

	const {
		isFetching: isGettingCellules,
		data: cellules,
		isError: errorGettingCellules
	} = useGetCellules({
		organization_id,
		company_id,
		sector_id
	});

	function handleOnChange(id: string): void {
		const fieldsToReset = hierarchyHandler.getHierarchiesFieldsToClear(field_name);

		if (fieldsToReset && id) {
			form.resetFields(fieldsToReset);
			form.setFieldValue(field_name, id);
		}
	}

	function handleOnClear(): void {
		const fieldsToReset = hierarchyHandler.getHierarchiesFieldsToClear(field_name);
		fieldsToReset && form.resetFields(fieldsToReset);
	}

	const isDisabled = !sector_id || !cellules || errorGettingCellules;

	return (
		<Form.Item name={field_name} label={I18n.get('Cell')}>
			<SelectWithCreation
				showSearch
				allowClear
				disabled={isDisabled}
				selectOptions={cellules}
				loading={isGettingCellules}
				onClear={handleOnClear}
				onChange={handleOnChange}
				placeholder={I18n.get('Cell')}
			/>
		</Form.Item>
	);
}
